// src/model/RentContract.ts
import {StorageLocationKey} from "./StorageLocation";
import {RentContractDocument} from "./RentContractDocument";

export interface RentContract {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    startDate: string;      // or Date, if you're converting
    endDate: string;// or Date
    type: RentContractType;
    monthlyPrice: number;
    description: string;
    storageLocation: StorageLocationKey;
    documents: RentContractDocument[]
    // storageLocation, etc., if needed
}

export enum RentContractType{
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY"
}
